import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getClientes = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/clientespro?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearCliente = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/clientespro', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateCliente = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/clientespro/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteCliente = (Id) => Axios.delete(`/clientespro/${Id}`);
